<template>
    <div class="app-message-box">
        <notification v-for="(notification) in notifications"
                      :key="notification.id"
                      :text="notification.text"
                      :type="notification.type"
                      :time="notification.time"
                      @close="handleCloseNotification(notification.id)">
        </notification>
    </div>
</template>

<script>
    import {mapState, mapMutations} from 'vuex'
    import Notification from "./Notification";

    export default {
        name: 'notification-list',
        components: {
            Notification,
        },
        computed: {
            ...mapState({
                notifications: state => state.notifications
            }),
        },
        methods: {
            ...mapMutations([
                'deleteNotification'
            ]),
            handleClose() {
                this.switchPopup(false);
            },
            handleCloseNotification(index) {
                this.deleteNotification(index)
            }

        },
    }
</script>

<style scoped>

</style>
